document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartFooter', () => ({
    footerRoot: null,
    cartPending: 0,
    init() {
      this.footerRoot = this.$root;
      this.cartPending = ThemeCart.pending;
      this._onCartPending = (event) => { this.cartPending = event.detail.pending; };
      window.addEventListener('shapes:cart:pendingchange', this._onCartPending);
      this._onCartUpdate = (event) => {
        if (!this.footerRoot.isConnected) return;
        ThemeCart.renderEvent(event, (snapshot) =>
          Alpine.morph(this.footerRoot, snapshot.footer.outerHTML), 'footer'
        );
      };
      window.addEventListener('shapes:modalcart:afteradditem', this._onCartUpdate);
      window.addEventListener('shapes:modalcart:cartqtychange', this._onCartUpdate);
    },
    destroy() {
      window.removeEventListener('shapes:cart:pendingchange', this._onCartPending);
      window.removeEventListener('shapes:modalcart:afteradditem', this._onCartUpdate);
      window.removeEventListener('shapes:modalcart:cartqtychange', this._onCartUpdate);
    },
  }));
});
